(function () {
    'use strict';

    angular
        .module('expenses')
        .config(ExpensesRoute);

    /* @ngInject */
    function ExpensesRoute($stateProvider) {
        $stateProvider
            .state('root.expenses', {
                cache: false,
                abstract: true,
                url: '/expenses',
                resolve: {
                    expenses: () => null,
                    expense: () => null,
                    currencies: () => null,
                    payees: () => null,
                    paymentMethods: () => null,
                    bankAccounts: () => null,
                    itemCategories: () => null,
                    itemSemesters: () => null,
                    itemCostCenters: () => null,
                }
            })
            // TODO: add 'back' history functionality (https://christopherthielen.github.io/ui-router-extras/#/previous)
            .state ('root.expenses.create', {
                url: '/create',
                // TODO: consider using $templateCache (https://docs.angularjs.org/api/ng/service/$templateCache)
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/expenses/templates/expenses-form.html',
                        controller: 'ExpensesController',
                        controllerAs: 'expenses'
                    }
                },
                resolve: {
                    currencies,
                    payees,
                    paymentMethods,
                    bankAccounts,
                    itemCategories,
                    itemSemesters,
                    itemCostCenters,
                }
            })
            .state ('root.expenses.list', {
                url: '/list',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/expenses/templates/expenses-list.html',
                        controller: 'ExpensesController',
                        controllerAs: 'expenses'
                    }
                },
                params: {
                    filters: null,
                },
                resolve: {
                    expenses,
                    payees,
                    itemCostCenters,
                    paymentMethods,
                    bankAccounts,
                }
            })
            .state ('root.expenses.read', {
                url: '/view/:id',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/expenses/templates/expenses-view.html',
                        controller: 'ExpensesController',
                        controllerAs: 'expenses'
                    }
                },
                resolve: {
                    expense,
                    paymentMethods,
                    bankAccounts,
                }
            })
            .state ('root.expenses.edit', {
                url: '/edit/:id',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/expenses/templates/expenses-form.html',
                        controller: 'ExpensesController',
                        controllerAs: 'expenses'
                    }
                },
                resolve: {
                    expense,
                    currencies,
                    payees,
                    paymentMethods,
                    bankAccounts,
                    itemCategories,
                    itemSemesters,
                    itemCostCenters,
                }
            })

            .state('root.expenses.report', {
                    cache: false,
                    abstract: true,
                    url: '/reports'
            })
            .state ('root.expenses.report.expensesbysemester', {
                url: '/bysemester',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/expenses/reports/expensesbysemester/reportFilter.html',
                        controller: 'ExpensesBySemesterController',
                        controllerAs: 'expensesBySemester'
                    }
                },
                resolve: {                    
                    itemCostCenters,
                }
            }).state ('root.expenses.report.expensescomparative', {
                url: '/comparative',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/expenses/reports/expensescomparative/reportFilter.html',
                        controller: 'ExpensesComparativeController',
                        controllerAs: 'expensesComparative'
                    }
                },
                resolve: {                    
                    itemCostCenters,
                }
            });

    }

    function expense($state, $stateParams, toastr, ExpensesService) {
        return ExpensesService.getExpenseById($stateParams.id)
        .then(expense => {
            if (!expense) {
                toastr.error('Sorry, this expense can not be found.')
                return $state.go('root.expenses.list', $stateParams, {reload:true});
            } 
            return expense;
        })
    }
    
    function expenses($stateParams, ExpensesService) { 
        return ExpensesService.listExpenses($stateParams.filters);
    }

    function currencies(ExpensesService) { 
        return ExpensesService.listExpenseCurrencies();
    }

    function payees(ExpensesService) { 
        return ExpensesService.listExpensePayees();
    }

    function paymentMethods(ExpensesService) { 
        return ExpensesService.listExpensePaymentMethods();
    }

    function bankAccounts(ExpensesService) { 
        return ExpensesService.listExpenseBankAccounts();
    }

    function itemCategories(ExpensesService) { 
        return ExpensesService.listExpenseItemCategories();
    }

    function itemSemesters(ExpensesService) { 
        return ExpensesService.listExpenseItemSemesters();
    }

    function itemCostCenters(ExpensesService) { 
        return ExpensesService.listExpenseItemCostCenters();
    }
})();